export const TST_BLESSED_ID_COLUMN_SELECTION = "selection";
export const TST_DEFAULT_PAGE_SIZE = 50;

/**
 * Shared column-width scale for all TST tables. Use these instead of raw
 * pixel literals or per-feature size constants so column widths stay aligned
 * across the app. `CHECKBOX` is for selection/icon columns; the rest are a
 * t-shirt scale for content columns.
 */
export const TST_COLUMN_SIZE = {
    CHECKBOX: 50,
    XS: 100,
    S: 150,
    M: 200,
    L: 250,
    XL: 350,
    XXL: 500,
} as const;
